import React, { useState, useEffect } from "react";
import logo from "../../assets/images/logo/logo-pipe.png";
import "../../assets/css/layout/header.css";

export default function Header({ onMenuClick }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  // Monitors page window offset positions to apply adaptive color blending effects
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navItems = [
    { label: "Home", id: "hero" },
    { label: "Products", id: "products" },
    { label: "Services", id: "services" },
    { label: "About Us", id: "about" },
    { label: "Contract Quotes", id: "contact" },
  ];

  const handleNavClick = (id) => {
    onMenuClick(id);
    setIsMenuOpen(false);
  };

  const handleBookingClick = () => {
    onMenuClick("contact");
    setIsMenuOpen(false);
  };

  return (
    <>
      <header className={`main-navbar ${isScrolled ? "navbar-scrolled" : ""}`}>
        <div className="container header-flex-layout">
          {/* Brand Logo Container */}
          <div
            className="navbar-brand-wrapper"
            onClick={() => handleNavClick("hero")}
          >
            <img
              src={logo}
              alt="Solid Pipes Logo"
              className="header-logo"
              loading="eager"
            />
          </div>

          {/* Mobile Hamburger Trigger Component */}
          <button
            className={`hamburger-toggle-btn ${isMenuOpen ? "is-active" : ""}`}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle navigation menu"
            aria-expanded={isMenuOpen}
          >
            <span className="hamburger-bar"></span>
            <span className="hamburger-bar"></span>
            <span className="hamburger-bar"></span>
          </button>

          {/* Navigation Context Link Panel Drawer */}
          <nav
            className={`navbar-links-panel ${isMenuOpen ? "panel-open" : ""}`}
          >
            <div className="navbar-menu-items">
              {navItems.map((item, idx) => (
                <button
                  key={idx}
                  onClick={() => handleNavClick(item.id)}
                  className="navbar-nav-btn"
                >
                  {item.label}
                </button>
              ))}
            </div>

            {/* Primary Header Action Button */}
            <button className="navbar-book-btn" onClick={handleBookingClick}>
              Book Now
            </button>
          </nav>
        </div>
      </header>

      {/* Mobile Drawer Overlay Background Dimmer Blur */}
      {isMenuOpen && (
        <div
          className="navbar-mobile-overlay"
          onClick={() => setIsMenuOpen(false)}
        />
      )}
    </>
  );
}
